import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Membri from "./pages/Membri";
import Eventi from "./pages/Eventi";
import Adesione from "./pages/Adesione";
import Contatti from "./pages/Contatti";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09 }}>
      <BrowserRouter>
        <ScrollToTop />
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/membri" element={<Membri />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/adesione" element={<Adesione />} />
            <Route path="/contatti" element={<Contatti />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
